// extracted by mini-css-extract-plugin
var _1 = "AdminSelect_container__t0re1";
var _2 = "AdminSelect_error__nNRNA";
var _3 = "AdminSelect_errorMessage__YXLxy";
var _4 = "AdminSelect_label__hSud5";
var _5 = "AdminSelect_select__3r3Hy";
export { _1 as "container", _2 as "error", _3 as "errorMessage", _4 as "label", _5 as "select" }
